import React from "react"
import { Link } from "gatsby"
import PropTypes from "prop-types"
import Img from "gatsby-image"

import IconArrow from "../components/iconArrow"

const EntryPreview = ({ date, photographer, location, img, entryId }) => {
  return (
    <Link className="entrycard" to={`/${entryId}`}>
      <div className="entrycard__content">
        <div className="entrycard__thumb">
          {img ? (
            <Img
              fixed={img}
              alt={
                photographer
                  ? photographer[0].data.photographerName + ", " + date
                  : "No Picture"
              }
            />
          ) : (
            ""
          )}
        </div>
        <div className="entrycard__info">
          <div className="entrycard__meta">
            <span className="entrycard__date">{date}</span>
            <p className="entrycard__photographer">
              {photographer[0].data.photographerName}
            </p>
            <p className="entrycard__location">{location}</p>
          </div>
          <IconArrow className="entrycard__icon" />
        </div>
      </div>
    </Link>
  )
}

EntryPreview.propTypes = {
  date: PropTypes.string,
  photographer: PropTypes.array,
  location: PropTypes.string,
  entryId: PropTypes.string,
}

EntryPreview.defaultProps = {
  date: ``,
  photographer: ``,
  location: ``,
  entryId: ``,
}

export default EntryPreview
